<template>
  <div class="main-wrap">
    <div style="position:'relative'">
      <el-card shadow="always" v-bind:class="{'mobil-navbar': isMobil, 'header-card': !isMobil}">
        <div class="card-contend">
          <el-button
            class="hidden-sm-and-up"
            icon="el-icon-menu"
            circle
            @click="menuToggle()"
          ></el-button>
          <div class="logo-container" v-bind:class="{ 'mobil-logo': isMobil, 'header-logo-container':!isMobil }">
            <tenant-logo v-if="useTenantLogo" :height="isMobil ? '40px' : '80px'" :default-text="'MSP'"/>
            <img v-else :src="logo" alt="" v-bind:class="{ 'mobil-img': isMobil, 'header-logo':!isMobil }">
          </div>
          <div class="tenant-display hidden-xs-only" v-if="localTenant">
            <i class="el-icon-office-building"></i> {{ localTenant.name }}
          </div>
          <el-dropdown trigger="click" v-if="user" >
            <div>
              <el-button icon="el-icon-user-solid" circle class="hidden-sm-and-up">
              </el-button>
              <span class="user-drop-down hidden-xs-only">
                      {{user.firstName}} {{user.lastName}}<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-if="isAdmin" @click.native="goToTenantSettings">{{$t('settings.selfTenantSettings')}}</el-dropdown-item>
              <el-dropdown-item :divided="isAdmin" @click.native="onLogout">{{$t('main.logout')}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-card>
    </div>
    <div class="main-content-wrap">
      <el-menu
        v-bind:class="{'mobil-menu': isMobil}"
        class="page-menu"
        v-bind:style="{left: showMenu + 'px'}"
        :router="true"
        :default-active="$router.history.current.path"
        @open="handleOpen"
        @close="handleClose"
        background-color="#545c64"
        text-color="#fff"
        active-text-color="#ffd04b">
        <el-menu-item index="/app/current" :route="{path: '/app/current'}" @click="menuToggle()">
          <span>{{$t('nav.current_reports')}}</span>
        </el-menu-item>
        <el-menu-item index="/app/new" :route="{path: '/app/new'}" @click="menuToggle()" >
          <span>{{$t('nav.new_report')}}</span>
        </el-menu-item>
        <el-menu-item index="/app/categories" :route="{path: '/app/categories'}" @click="menuToggle()" v-if="isAdmin || isSuperAdmin">
          <span>{{$t('nav.report_categories')}}</span>
        </el-menu-item>
        <el-menu-item  @click="openAlert" v-if="isAdmin" index="/app/settings" :route="{path: '/app/settings'}">
          <span>{{$t('nav.customer_settings')}}</span>
        </el-menu-item>
        <el-menu-item @click="openAlert" v-if="isAdmin" index="/app/server-settings" :route="{path: '/app/server-settings'}">
          <span>{{$t('nav.server_settings')}}</span>
        </el-menu-item>
        <el-menu-item v-if="isSuperAdmin" index="/app/tenants" :route="{path: '/app/tenants'}" @click="menuToggle()">
          <span>{{$t('nav.tenant_management')}}</span>
        </el-menu-item>
        <el-menu-item v-if="isSuperAdmin" index="/app/global" :route="{path: '/app/global'}" @click="menuToggle()">
          <span>{{$t('nav.global_overview')}}</span>
        </el-menu-item>
      </el-menu>
      <div id="content" v-bind:class="{ 'content-mobil' : isMobil}">
        <transition mode="out-in" name="el-fade-in">
          <router-view/>
        </transition>
        <!--Mobil alert  -->
        <el-dialog
          :visible.sync="displayAlert"
          width="300px"
          title="Warning"
          center>
          <span>{{$t('notification.mobil_alert')}}</span>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="displayAlert = false">ok</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import mspLogo from '../assets/msp-logo.png'
import {createNamespacedHelpers} from 'vuex'
import TenantLogo from '@/components/tenants/TenantLogo.vue'

const authStateMappers = createNamespacedHelpers('auth')
const applicationStateMappers = createNamespacedHelpers('application')
const tenantStateMappers = createNamespacedHelpers('tenant')

export default {
  name: 'Main',
  components: {
    TenantLogo
  },
  data() {
    return {
      logo: mspLogo,
      showMenu: '0',
      displayAlert: false,
      useTenantLogo: false, // Controls whether to use the tenant logo or default
      localTenant: null
    }
  },
  computed: {
    ...authStateMappers.mapGetters({user: 'getUser', isAdmin: 'isAdmin'}),
    ...applicationStateMappers.mapGetters({ isMobil: 'isMobil' }),
    ...authStateMappers.mapGetters({isSuperAdmin: 'isSuperAdmin'}),
    ...tenantStateMappers.mapGetters({currentTenant: 'getSelectedTenant'})
  },
  mounted() {
    this.getMyAccount();
    this.fetchTenant();
    window.addEventListener('resize', () => {
      if(!this.isMobil||window.innerWidth>767)this.showMenu = 0
      else this.showMenu=-240
    });
  },
  methods: {
    ...authStateMappers.mapActions(['getMyAccount', 'logoutAction']),
    ...tenantStateMappers.mapActions(['getSelf']),
    handleOpen(key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath)
    },
    onLogout() {
      this.logoutAction().then(() => {
        this.$router.push({name: 'Login'})
      })
    },
    menuToggle() {
      if(this.isMobil){
        if(this.showMenu == 0)this.showMenu=-240
        else this.showMenu = 0
      }
    },
    openAlert() {
      if(this.isMobil){
        this.displayAlert=true;
      }
    },
    fetchTenant() {
      import('@/services/TenantService.class').then(({tenantService}) => {
        tenantService.getSelf()
          .then(response => {
            this.localTenant = response.data;

            if (response.data && response.data.logo) {
              this.useTenantLogo = true;
            }

            this.$store.commit('tenant/setSelectedTenant', response.data);
          })
          .catch(error => {
            console.error('Error fetching tenant:', error);
          });
      });
    },
    goToTenantSettings() {
      this.$router.push({ path: '/app/tenant/self' });
    }
  }
}
</script>

<style>
:root {
  --primary: #409EFF;
  --primary-dark: #2d7dd2;
  --success: #67C23A;
  --danger: #F56C6C;
  --border: #e8e8ee;
  --text-primary: #1a1a2e;
  --text-secondary: #909399;
  --bg-hover: #f5f7ff;
  --bg-surface: #ffffff;
  --entra: #6366f1;
  --entra-dark: #4f46e5;
  --entra-bg: #efeefe;
}
</style>

<style lang="scss" scoped>
.mobil-img{
  height: 40px;
}
.logo-container {
  display: flex;
  align-items: center;
  justify-content: center;
}
.mobil-logo {
  height: 40px;
}
.header-logo-container {
  height: 80px;
}
.mobil-navbar{
  position: fixed;
  width: 100vw;
  z-index: 16;
  .card-contend {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
.mobil-menu{
  position: fixed;
  top: 80px;
  height: 100vh;
  z-index: 15;
  transition: 0.5s;
}
.content-mobil{
  margin-top: 70px;
}
.user-drop-down {
  font-weight: 600;
  cursor: pointer;
  font-size: 14pt;
  user-select: none;

  &:focus {
    outline: none;
  }
}

.header-card {
  position: relative;

  .header-logo {
    height: 80px;
  }

  .card-contend {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

.main-wrap {
  min-height: 100%;
  display: flex;
  flex-direction: column;

  .header-card {

  }

  .main-content-wrap {
    flex-grow: 1;
    display: flex;
    flex-direction: row;

    .page-menu {
      width: 240px;
      min-width: 240px;
    }
  }
}

#content {
  box-sizing: border-box;
  padding: 2rem;
  width: 100%;
  min-width: 0;
  height: 100%;
  display: flex;

  > div {
    width: 100%;
  }
}

.tenant-display {
  margin-right: 15px;
  font-weight: 500;
  color: #409EFF;
  padding: 5px 10px;
  background-color: rgba(0, 0, 0, 0.05);
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  font-size: 12pt;
  display: flex;
  align-items: center;

  i {
    margin-right: 5px;
    color: #409EFF;
  }
}

.user-drop-down {
  font-weight: 600;
  cursor: pointer;
  font-size: 14pt;
  user-select: none;

  &:focus {
    outline: none;
  }
}
</style>
